import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import background from "./images/background.jpg"
import movie_website from "./images/movie_website.png"
import Book_Bazaar from "./images/Book Bazaar.png"
import QR_and_UPI_QR_Code_Generator from "./images/QR and UPI QR Code Generator.png"
import "./Project.css"

const Project = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <>
      <section className='project' id="projects">
        <h1 style={{ color: "#fff", textAlign: "center", textTransform: "uppercase", fontWeight: "900", fontSize: "30px" }}>Projects</h1></section>

      <Carousel responsive={responsive} infinite={true} className="project-slider">
        <div className="project-item ">
          <img src={Book_Bazaar} alt="Project" />
          <h2>Book Bazaar</h2>
          <p> Built a responsive book selling website using React Js, Node Js, Global Context, useContext Hook, Local Storage and Razorpay Api for Payments.
          </p>
          <div className="button-section">
            <a href="https://bookbazaar-hawkeye2108.netlify.app/" target="_blank" className="project_btn">VIEW</a>
            <a href="https://github.com/Hawkeye2108/E-Commerce" target="_blank" className="project_btn">SOURCE</a>
          </div>
        </div>
        <div className="project-item ">
          <img src={background} alt="Project" />
          <h2>To-Do App</h2>
          <p>Built To-Do App to add, update, delete to-dos of a user using Expo, React Native and Async Storage
            to store and retain user state even after the app is refreshed.</p>
          <a href="https://github.com/Hawkeye2108/Todo" target="_blank" className="project_btn">SOURCE</a>
        </div>
        <div className="project-item ">
          <img src={QR_and_UPI_QR_Code_Generator} alt="Project" />
          <h2>QR and UPI QR Code Generator</h2>
          <p>Built a project that generates QR using URL and UPI QR using Name and
            VPA using React Js, React Hooks, Node.js in Backend and NPCI’s API.</p>
          <div className="button-section">
            <a href="https://qrcodeandupiqrcodegenerator.netlify.app/" target="_blank" className="project_btn">VIEW</a>
            <a href="https://github.com/Hawkeye2108/QR-Code" target="_blank" className="project_btn">SOURCE</a>
          </div>
        </div>
        <div className="project-item ">
          <img src={background} alt="Project" />
          <h2>Grocery Website</h2>
          <p>Grocery website made using HTML,CSS,JavaScript and Firebase and some basic functionalities like login and Add to Cart.</p>
          <a href="https://github.com/Hawkeye2108/Grocery" target="_blank" className="project_btn">SOURCE</a>
        </div>
        <div className="project-item ">
          <img src={movie_website} alt="Project" />
          <h2>Movie Website</h2>
          <p>Movie website made using React Js,React Hooks and API to search your favourite movie.</p>
          <div className="button-section">
            <a href="https://movie-website-hawkeye2108.netlify.app/" target="_blank" className="project_btn">VIEW</a>
            <a href="https://github.com/Hawkeye2108/Movie-Website" target="_blank" className="project_btn">SOURCE</a>
          </div>
        </div>
      </Carousel>
    </>
  )
}

export default Project